import { render, staticRenderFns } from "./MobileFallback.vue?vue&type=template&id=52163eba&"
import script from "./MobileFallback.vue?vue&type=script&lang=js&"
export * from "./MobileFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports